import React, { FC, useState } from 'react';

import { HandicapEntry } from '../../handicaps/ryder-cup/handicap-entry';
import { HoleScores } from '../../scores/ryder-cup/hole-scores';
import { MatchScoreCard } from '../../score-card/match-score-card';
import { Course, Match, PlayerResult } from '../../../../../database.schema';
import { MatchDayResultScoreCard, useFetchMatchDayResultScoreCard } from '../../../../api/hooks/use-fetch-match-day-results-with-scorecard';
import { useParams } from 'react-router-dom';

export const AddScoreCard: FC = (): JSX.Element => {
  let params = useParams();
  const tournamentIndex = Number(params.tournamentIndex);
  const dayIndex = Number(params.dayIndex);
  const matchIndex = Number(params.matchIndex);
  const { isLoading, error, data } = useFetchMatchDayResultScoreCard(tournamentIndex, dayIndex);
  const { config, course, results, format, startingHole } = data as MatchDayResultScoreCard;
  const [recordedMatchStore, setRecordedMatchStore] = useState<Match>({
    ...results[matchIndex],
    resultByHole: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-'],
  });
  const [showHandicapEntry, setShowHandicapEntry] = useState(true);
  const [showScoreEntry, setShowScoreEntry] = useState(true);

  if (showHandicapEntry) {
    const editingMatch = recordedMatchStore.team1.players.some((player: PlayerResult) => player.round.courseHandicap !== -1);
    return (
      <HandicapEntry
        config={config}
        editingMatch={editingMatch}
        startingHole={startingHole}
        matchIndex={matchIndex}
        course={course}
        recordedMatch={recordedMatchStore}
        setRecordedMatch={setRecordedMatchStore}
        setShowHandicapEntry={setShowHandicapEntry}
        format={format as 'Pairs' | 'Singles'}
      />
    );
  }
  if (!showHandicapEntry && showScoreEntry) {
    return (
      <HoleScores startingHole={startingHole} recordedMatch={recordedMatchStore} setRecordedMatch={setRecordedMatchStore} course={course} setShowScoreEntry={setShowScoreEntry} />
    );
  }

  return (
    <MatchScoreCard
      startingHole={startingHole}
      course={course}
      recordedMatch={recordedMatchStore}
      showScoreEntry={setShowScoreEntry}
      matchIndex={matchIndex}
      resultIndex={dayIndex}
      format={format as 'Pairs' | 'Singles'}
    />
  );
};
